export default "__VITE_ASSET__BrfEbJ4a__"